export default "__VITE_ASSET__ClmHwbID__"